import LactationChart from "./lactation-chart.vue";

export default LactationChart;



// WEBPACK FOOTER //
// ./src/components/_charts/lactation/index.js